import React from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import AboutSection from '../components/AboutSection';
import MediaSection from '../components/MediaSection';
import SectorsSection from '../components/SectorsSection';
import SustainabilitySection from '../components/SustainabilitySection';
import QuoteSection from '../components/QuoteSection';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';

const HomePage = () => {
  return (
    <div>
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <AboutSection />
      <MediaSection />
      <SectorsSection />
      <SustainabilitySection />
      <QuoteSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default HomePage;